import { render, staticRenderFns } from "./ModernField.vue?vue&type=template&id=ec2c8ee2&scoped=true&"
import script from "./ModernField.vue?vue&type=script&lang=js&"
export * from "./ModernField.vue?vue&type=script&lang=js&"
import style0 from "./ModernField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c8ee2",
  null
  
)

export default component.exports